/**
 * SessionStorage keys
 */
const STORAGE_KEYS = {
  API_KEY: 'warpway:apiKey',
} as const;

/**
 * Store API key in sessionStorage
 */
export function saveApiKey(apiKey: string): void {
  try {
    sessionStorage.setItem(STORAGE_KEYS.API_KEY, apiKey);
  } catch (error) {
    console.error('[Warpway SDK] Failed to save API key:', error);
  }
}

/**
 * Get API key from sessionStorage
 */
export function getApiKey(): string | null {
  try {
    return sessionStorage.getItem(STORAGE_KEYS.API_KEY);
  } catch (error) {
    console.error('[Warpway SDK] Failed to get API key:', error);
    return null;
  }
}

/**
 * Remove API key from sessionStorage
 */
export function clearApiKey(): void {
  try {
    sessionStorage.removeItem(STORAGE_KEYS.API_KEY);
    // Also remove old cached site info if it exists (for backwards compatibility)
    sessionStorage.removeItem('warpway:siteInfo');
  } catch (error) {
    console.error('[Warpway SDK] Failed to clear API key:', error);
  }
}
